import { useState } from "react";
import { loginUser } from "../Auth";
import { normalizeEmail } from "../utils/email";

const useLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userData, setUserData] = useState(null);

  const login = async () => {
    setIsSubmitting(true);
    setError("");

    try {
      const res = await loginUser({ email: normalizeEmail(email), password });

      if (res.success) {
        setUserData(res.user);
        // Flatten so Login.js can read res.user / res.modules directly
        return {
          success: true,
          user: res.user,
          modules: res.modules || [],
        };
      }

      const message = res.message || "Login failed";
      setError(message);
      return { success: false, message };
    } catch (err) {
      const msg = err?.message || "An unexpected error occurred";
      setError(msg);
      return { success: false, message: msg };
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isSubmitting,
    login,
    userData,
  };
};

export default useLogin;
